<footer class="proc__footer section__bg--grey">

  <div class="container">

    <div class="row">

      <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 d-flex flex-column">
        <a routerLink="/">
          <div class="proc__logo proc__logo__footer">
            <img [src]="'assets/img/logo_gp.svg'" alt="logo">
            <div class="proc__logo__text">
              {{selectedVpo?.name}}
            </div>
          </div>
        </a>
        <div class="proc__footer__address">
          Телефон: <a href="javascript:;"> {{selectedVpo?.contacts}}</a>
          <br>
          {{selectedVpo?.address}}<br>
        </div>
        <a routerLink="/{{selectedVpo?.code}}/contacts" class="link link--black proc__footer__link"> {{selectedVpo?.name}} на карте</a>
        <!-- a href="https://gvp.gov.ru/old-version/" class="link link--black proc__footer__link"> Старая версия сайта</a -->
        <!-- a href="#" class="link link--black proc__footer__link">Органы военной прокуратуры на карте</a -->
        <div class="proc__footer__socials"></div>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 col-lg-offset-1 col-md-offset-1">
        <div class="proc__footer__title">Основные разделы</div>
        <nav class="proc__footer__nav">
          <a routerLink="/{{selectedVpo?.code}}/about" class="proc__footer__nav__link">О ведомстве</a>
          <a routerLink="/{{selectedVpo?.code}}/contacts" class="proc__footer__nav__link">Контакты</a>
          <!-- a href="javascript:;" class="proc__footer__nav__link">Открытые данные</a>
          <a href="javascript:;" class="proc__footer__nav__link">Для СМИ</a -->
          <a routerLink="/{{selectedVpo?.code}}/news" class="proc__footer__nav__link">Новости</a>
          <a routerLink="/{{selectedVpo?.code}}/documents" class="proc__footer__nav__link">Документы</a>
          <a routerLink="/{{selectedVpo?.code}}/events" class="proc__footer__nav__link">Деятельность</a>
        </nav>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
        <div class="proc__footer__title">Дополнительные возможности</div>
        <nav class="proc__footer__nav">
          <a routerLink="/{{selectedVpo?.code}}/reception" class="proc__footer__nav__link">Обращение в прокуратуру</a>
          <a routerLink="/{{selectedVpo?.code}}/application" class="proc__footer__nav__link">Мобильное приложение</a>
        </nav>
      </div>

    </div>

    <div class="row proc__footer__bottom .row-eq-height">
       <span class="col-md-6 proc__footer__copy">
        © 2010-{{currentYear}} Главная военная прокуратура
        <br>
        Все права защищены
       </span>
    </div>

  </div>

</footer>
